package data.search_data

import models.SearchData

// Search suggestions (78)
val ChichenSearchSuggestions = listOf(
    "stamp",
    "yoke",
    "hacha",
    "male",
    "female",
    "serpentine",
    "andesite",
    "figure",
    "cylindrical",
    "chisel",
    "earflare",
    "relief",
    "model",
    "plate",
    "ornament",
    "red",
    "censer",
    "jade",
    "slip",
    "gold",
    "implements",
    "musical",
    "jar",
    "stone",
    "sculpture",
    "pendant",
    "rattle",
    "monkey",
    "seated",
    "mythological",
    "beads",
    "ceramics",
    "ornaments",
    "pigment",
    "metal",
    "instruments",
    "head",
    "deity",
    "ceramic",
    "shell",
    "containers",
    "flint",
    "bird",
    "double",
    "bead",
    "ochre",
    "carved",
    "face",
    "jadeite",
    "tripod",
    "tubular",
    "vessel",
    "celt",
    "bowl",
    "eagle",
    "paint",
    "limestone",
    "scene",
    "lid",
)

// Machu Picchu (366)
val ChichenSearchData = listOf(
    SearchData(
        550,
        317120,
        "Earflare",
        "earflare|jade|stone-ornaments",
        "ao/mobile-large/VS1994_35_582.JPG",
        1.18
    ),
    SearchData(
        700,
        313336,
        "Handle (?)",
        "tube|bone|bone/ivory-sculpture",
        "ao/mobile-large/vs1979_206_1144.jpg",
        0.28
    ),
    SearchData(
        1400,
        317635,
        "Gouge",
        "chisel|stone|stone-implements",
        "ao/mobile-large/vs1994_35_771.jpg",
        3.40
    ),
    SearchData(
        1250,
        318229,
        "Metate Fragment",
        "metate fragment|stone|stone-sculpture",
        "ao/mobile-large/X.180.10.JPG",
        1.52
    ),
    SearchData(
        1400,
        317303,
        "Chisel",
        "chisel|stone|stone-implements",
        "ao/mobile-large/VS1994_35_447.JPG",
        1.43
    ),
    SearchData(
        1100,
        313348,
        "Monkey Vessel",
        "vessel|onyx marble, pyrite, shell|stone-containers",
        "ao/mobile-large/DP-25032-001.jpg",
        0.80
    ),
    SearchData(
        1400,
        317267,
        "Celt",
        "celt|stone|stone-implements",
        "ao/mobile-large/hz1994_35_401.jpg",
        0.58
    ),
    SearchData(
        200,
        312581,
        "House Model",
        "house model|ceramic|ceramics-sculpture",
        "ao/mobile-large/DP-23907-001.jpg",
        0.78
    ),
    SearchData(
        1350,
        312599,
        "Pedestal Bowl",
        "bowl|ceramic|ceramics-containers",
        "ao/mobile-large/DP102175.jpg",
        1.03
    ),
    SearchData(
        850,
        309404,
        "Monumental Figure",
        "figure|limestone|stone-sculpture",
        "ao/mobile-large/DP104844.jpg",
        0.44
    ),
    SearchData(
        750,
        501839,
        "Pottery Rattle",
        "pottery rattle|clay|idiophone-shaken-rattle",
        "mi/mobile-large/DP-23770-001.jpg",
        0.80
    ),
    SearchData(
        1400,
        317227,
        "Celt",
        "celt|stone|stone-implements",
        "ao/mobile-large/hz1994_35_361.jpg",
        0.62
    ),
    SearchData(
        749,
        503940,
        "Double Whistle",
        "double whistle|pottery, paint|aerophone-whistle flute",
        "mi/mobile-large/DT4624a.jpg",
        0.78
    ),
    SearchData(
        400,
        309713,
        "Yoke-Form Vessel",
        "vessel with lid|ceramic|ceramics-containers",
        "ao/mobile-large/DT11169.jpg",
        0.80
    ),
    SearchData(
        1400,
        317234,
        "Celt",
        "celt|stone|stone-implements",
        "ao/mobile-large/hz1994_35_368.jpg",
        0.87
    ),
    SearchData(
        -650,
        313138,
        "Seated Bench Figure",
        "figure|serpentine|stone-sculpture",
        "ao/mobile-large/DT9963.jpg",
        0.80
    ),
    SearchData(
        1400,
        317210,
        "Celt",
        "celt|stone|stone-implements",
        "ao/mobile-large/hz1994_35_343.jpg",
        0.79
    ),
    SearchData(
        700,
        310651,
        "Vessel,  Palace Scene",
        "vessel|ceramic|ceramics-containers",
        "ao/mobile-large/1978.412.202_a.JPG",
        0.77
    ),
    SearchData(
        1400,
        317211,
        "Celt",
        "celt|stone|stone-implements",
        "ao/mobile-large/hz1994_35_344.jpg",
        0.68
    ),
    SearchData(
        1400,
        317248,
        "Celt",
        "celt|stone|stone-implements",
        "ao/mobile-large/hz1994_35_382.jpg",
        0.44
    ),
    SearchData(
        -1000,
        314946,
        "Bird Vessel",
        "vessel|ceramic, red ochre|ceramics-containers",
        "ao/mobile-large/DP23080.jpg",
        0.83
    ),
    SearchData(
        700,
        313315,
        "Vessel with Deity Figures",
        "vessel|ceramic|ceramics-containers",
        "ao/mobile-large/1979.206.1122_a.JPG",
        0.81
    ),
    SearchData(
        1400,
        317099,
        "Stone Chisel",
        "chisel|stone|stone-implements",
        "ao/mobile-large/hz1994_35_334.jpg",
        0.87
    ),
    SearchData(
        1000,
        313091,
        "Ceremonial Metate",
        "metate|diabase|stone-implements",
        "ao/mobile-large/DP104835.jpg",
        1.00
    ),
    SearchData(
        1400,
        317314,
        "Eccentric Flint",
        "flint|flint|stone-implements",
        "ao/mobile-large/hz1994_35_458.jpg",
        0.22
    ),
    SearchData(
        700,
        319633,
        "Cylindrical Vessel",
        "vessel|ceramic|ceramics-containers",
        "ao/mobile-large/DP-13003-003.jpg",
        0.75
    ),
    SearchData(
        1400,
        317291,
        "Adze",
        "adze|stone|stone-implements",
        "ao/mobile-large/VS1994_35_435.JPG",
        0.63
    ),
    SearchData(
        -1000,
        312589,
        "Relief-Carved Bowl",
        "vessel|ceramic|ceramics-containers",
        "ao/mobile-large/DP296005.jpg",
        1.10
    ),
    SearchData(
        1550,
        310589,
        "Figure Vessel",
        "vessel|ceramic|ceramics-containers",
        "ao/mobile-large/DT10182.jpg",
        0.79
    ),
    SearchData(
        0,
        317600,
        "Temple Model",
        "temple model|ceramic|ceramics-sculpture",
        "ao/mobile-large/DP-23904-001.jpg",
        1.09
    ),
    SearchData(
        1400,
        317241,
        "Celt",
        "celt|stone|stone-implements",
        "ao/mobile-large/hz1994_35_375.jpg",
        0.86
    ),
    SearchData(
        775,
        310551,
        "Censer Support",
        "censer support|ceramic|ceramics-sculpture",
        "ao/mobile-large/DP102949.jpg",
        0.67
    ),
    SearchData(
        400,
        316299,
        "Pair of Earflare Frontals",
        "earflare frontals|jade (jadeite)|stone-ornaments",
        "ao/mobile-large/DP-14786-043.jpg",
        1.39
    ),
    SearchData(
        1410,
        321343,
        "Serpent Labret with Articulated Tongue",
        "labret|gold|metal-ornaments",
        "ao/mobile-large/DP-478-020.jpg",
        1.61
    ),
    SearchData(
        750,
        310474,
        "Hacha",
        "hacha|stone, pigment|stone-sculpture",
        "ao/mobile-large/DP-17617-001.jpg",
        0.76
    ),
    SearchData(
        700,
        310468,
        "Standing Male Figure",
        "male figure|ceramic|ceramics-sculpture",
        "ao/mobile-large/1978.412.6_1.jpg",
        0.87
    ),
    SearchData(
        1400,
        317101,
        "Stone Chisel",
        "chisel|stone|stone-implements",
        "ao/mobile-large/hz1994_35_336.jpg",
        0.67
    ),
    SearchData(
        -650,
        309987,
        "Duck-Face Ornament",
        "ornament|jadeite, pigment|stone-ornaments",
        "ao/mobile-large/DP-12761-009.jpg",
        1.09
    ),
    SearchData(
        1400,
        317222,
        "Celt",
        "celt|stone|stone-implements",
        "ao/mobile-large/hz1994_35_356.jpg",
        0.67
    ),
    SearchData(
        1400,
        317244,
        "Stone Chisel",
        "chisel|stone|stone-implements",
        "ao/mobile-large/hz1994_35_378.jpg",
        0.56
    ),
    SearchData(
        700,
        314311,
        "Cylindrical Vessel",
        "vessel|ceramic, slip, pigment|stone-containers",
        "ao/mobile-large/DP-575-001.jpg",
        0.75
    ),
    SearchData(
        900,
        309901,
        "Pedestal Bowl",
        "bowl|marble|stone-containers",
        "ao/mobile-large/DP-17794-001.jpg",
        0.80
    ),
    SearchData(
        1400,
        317233,
        "Celt",
        "celt|stone|stone-implements",
        "ao/mobile-large/hz1994_35_367.jpg",
        0.88
    ),
    SearchData(
        1399,
        318679,
        "Monkey stamp",
        "stamp|ceramic|ceramics-implements",
        "ao/mobile-large/vs00_5_1165.jpg",
        0.70
    ),
    SearchData(
        750,
        313386,
        "\"Smiling\" Figure",
        "male figure|ceramic|ceramics-sculpture",
        "ao/mobile-large/DP104829.jpg",
        0.89
    ),
    SearchData(
        1360,
        309861,
        "Deity Censer (Xantil)",
        "censer|ceramic, pigment|ceramics-sculpture",
        "ao/mobile-large/DT1256.jpg",
        0.80
    ),
    SearchData(
        800,
        310540,
        "Column, Costumed Figure",
        "column|limestone|stone-sculpture",
        "ao/mobile-large/DP-22128-001.jpg",
        0.64
    ),
    SearchData(
        700,
        314217,
        "Vessel, Mythological Scene",
        "vessel|ceramic|ceramics-containers",
        "ao/mobile-large/DP-571-001.jpg",
        0.74
    ),
    SearchData(
        600,
        310607,
        "Vessel, Seated Deities",
        "vessel|ceramic|ceramics-containers",
        "ao/mobile-large/DP-13003-005.jpg",
        0.75
    ),
    SearchData(
        800,
        312593,
        "Hacha, Head",
        "hacha|andesite|stone-sculpture",
        "ao/mobile-large/1979.206.371.jpg",
        1.22
    ),
    SearchData(
        750,
        312915,
        "Whistle with the Maize God emerging from a flower",
        "figure|ceramic, pigment|ceramics-sculpture",
        "ao/mobile-large/DT9945.jpg",
        0.80
    ),
    SearchData(
        350,
        318345,
        "Censer, Seated King",
        "censer|ceramic|ceramics-containers",
        "ao/mobile-large/DT4512.jpg",
        0.80
    ),
    SearchData(
        -650,
        310467,
        "Celt with Incised Profile",
        "celt|jade (jadeite)|stone-implements",
        "ao/mobile-large/DP-23470-001.jpg",
        0.72
    ),
    SearchData(
        0,
        314523,
        "Cylindrical Vessel",
        "vessel|ceramic, slip|ceramics-containers",
        "ao/mobile-large/DP101926.jpg",
        0.98
    ),
    SearchData(
        1049,
        319238,
        "Female figure",
        "figure|stone|stone-sculpture",
        "ao/mobile-large/vs00_5_6.jpg",
        0.51
    ),
    SearchData(
        1420,
        307744,
        "Stamp, Monkey",
        "stamp|ceramic|ceramics-implements",
        "ao/mobile-large/00.5.1164.jpg",
        0.80
    ),
    SearchData(
        1400,
        317100,
        "Stone Chisel",
        "chisel|stone|stone-implements",
        "ao/mobile-large/hz1994_35_335.jpg",
        0.94
    ),
    SearchData(
        1400,
        317217,
        "Celt",
        "celt|stone|stone-implements",
        "ao/mobile-large/hz1994_35_350.jpg",
        0.77
    ),
    SearchData(
        1100,
        307599,
        "Eagle Relief",
        "panel|andesite/dacite, paint|stone-sculpture",
        "ao/mobile-large/DP-20487-001.jpg",
        1.11
    ),
    SearchData(
        1400,
        317214,
        "Celt",
        "celt|stone|stone-implements",
        "ao/mobile-large/hz1994_35_347.jpg",
        0.66
    ),
    SearchData(
        1159,
        310268,
        "Eagle Pendant",
        "pendant|gold|metal-ornaments",
        "ao/mobile-large/DT5062.jpg",
        0.80
    ),
    SearchData(
        -1000,
        310556,
        "Bottle",
        "bottle|ceramic, pigment|ceramics-containers",
        "ao/mobile-large/hb_1978.412.104.jpg",
        0.76
    ),
    SearchData(
        1420,
        307748,
        "Stamp, Monkey",
        "stamp|ceramic|ceramics-implements",
        "ao/mobile-large/00.5.1177_b.jpg",
        0.67
    ),
    SearchData(
        1400,
        317247,
        "Celt",
        "celt|stone|stone-implements",
        "ao/mobile-large/hz1994_35_381.jpg",
        0.63
    ),
    SearchData(
        500,
        317885,
        "Bowl",
        "bowl|ceramic|ceramics-containers",
        "ao/mobile-large/1998.317.4.JPG",
        1.17
    ),
    SearchData(
        700,
        312596,
        "Seated Female Figure",
        "female figure|ceramic|ceramics-musical instruments",
        "ao/mobile-large/1979.206.374.JPG",
        0.72
    ),
    SearchData(
        1400,
        317216,
        "Celt",
        "celt|stone|stone-implements",
        "ao/mobile-large/hz1994_35_349.jpg",
        0.62
    ),
    SearchData(
        25,
        318346,
        "Spouted Jar",
        "jar|indurated limestone|stone-containers",
        "ao/mobile-large/DT4518.jpg",
        1.25
    ),
    SearchData(
        1400,
        317102,
        "Stone Chisel",
        "chisel|stone|stone-implements",
        "ao/mobile-large/hz1994_35_337.jpg",
        0.75
    ),
    SearchData(
        700,
        313149,
        "Canine Ornament",
        "ornament|shell (spondylus)|shell-ornaments",
        "ao/mobile-large/DP-25094-001.jpg",
        1.50
    ),
    SearchData(
        750,
        315883,
        "Bowl, Mythological Scene",
        "bowl|ceramic|ceramics-containers",
        "ao/mobile-large/DP-578-001.jpg",
        1.32
    ),
    SearchData(
        1400,
        317215,
        "Celt",
        "celt|stone|stone-implements",
        "ao/mobile-large/hz1994_35_348.jpg",
        0.71
    ),
    SearchData(
        1400,
        317213,
        "Celt",
        "celt|stone|stone-implements",
        "ao/mobile-large/hz1994_35_346.jpg",
        0.63
    ),
    SearchData(
        800,
        316813,
        "Jar, Ritual Scenes",
        "jar|ceramic, slip, pigment|ceramics-containers",
        "ao/mobile-large/1993.441_a.JPG",
        0.83
    ),
    SearchData(
        500,
        316645,
        "Deity Head Pendant",
        "pendant|jade|stone-ornaments",
        "ao/mobile-large/vs1991_362_2.jpg",
        0.73
    ),
    SearchData(
        500,
        309557,
        "Closed Yoke",
        "yoke|stone|stone-sculpture",
        "ao/mobile-large/DP-17792-001.jpg",
        1.53
    ),
    SearchData(
        -950,
        318473,
        "Blackware Bowl",
        "bowl|ceramic|ceramics-containers",
        "ao/mobile-large/DP705410.jpg",
        0.82
    ),
    SearchData(
        1400,
        317107,
        "Celt",
        "celt|stone|stone-implements",
        "ao/mobile-large/hz1994_35_342.jpg",
        0.73
    ),
    SearchData(
        -300,
        313316,
        "Bench Figure",
        "male figure|greenstone (muscovite-paragonite phyllite)|stone-sculpture",
        "ao/mobile-large/DP23089.jpg",
        0.78
    ),
    SearchData(
        1400,
        317226,
        "Celt",
        "celt|stone|stone-implements",
        "ao/mobile-large/hz1994_35_360.jpg",
        0.58
    ),
    SearchData(
        500,
        313235,
        "Hacha in the Shape of Bound Hands",
        "hacha|stone|stone-sculpture",
        "ao/mobile-large/DP104825.jpg",
        0.95
    ),
    SearchData(
        750,
        312643,
        "Yoke",
        "yoke|serpentine|stone-sculpture",
        "ao/mobile-large/DP-23864-001.jpg",
        1.46
    ),
    SearchData(
        1400,
        317359,
        "Tubular Bead",
        "bead|stone|beads-ornaments",
        "ao/mobile-large/VS1994_35_509.JPG",
        0.49
    ),
    SearchData(
        550,
        318444,
        "Grouped Pigment Jars",
        "jars|ceramic, pigment|ceramics-sculpture",
        "ao/mobile-large/DP-23881-001.jpg",
        1.37
    ),
    SearchData(
        400,
        313262,
        "Deity Figure",
        "figure|jade (pyroxene jadeite)|stone-sculpture",
        "ao/mobile-large/DP-23472-001.jpg",
        0.76
    ),
    SearchData(
        1400,
        317270,
        "Celt",
        "celt|stone|stone-implements",
        "ao/mobile-large/hz1994_35_404.jpg",
        0.47
    ),
    SearchData(
        1400,
        317301,
        "Celt-Form Pendant",
        "pendant|stone|stone-ornaments",
        "ao/mobile-large/VS1994_35_445.JPG",
        0.93
    ),
    SearchData(
        499,
        313330,
        "Bird Pendant",
        "pendant|jadeite|stone-ornaments",
        "ao/mobile-large/DP-17791-001.jpg",
        0.80
    ),
    SearchData(
        600,
        310527,
        "Stela Fragment with Glyphs",
        "stela fragment|stone|stone-sculpture",
        "ao/mobile-large/DT10173.jpg",
        1.03
    ),
    SearchData(
        1100,
        307598,
        "Eagle Relief",
        "panel|andesite or dacite, paint|stone-sculpture",
        "ao/mobile-large/DP-17616-001.jpg",
        1.08
    ),
    SearchData(
        1400,
        317350,
        "Bead",
        "bead|stone|beads-ornaments",
        "ao/mobile-large/hz1994_35_500.jpg",
        0.97
    ),
    SearchData(
        1400,
        317352,
        "Bead",
        "bead|stone|beads-ornaments",
        "ao/mobile-large/hz1994_35_502.jpg",
        1.01
    ),
    SearchData(
        400,
        312586,
        "Tripod Vessel",
        "vessel|ceramic, red ochre|ceramics-containers",
        "ao/mobile-large/DP302441.jpg",
        1.10
    ),
    SearchData(
        500,
        314557,
        "Seated Figure Censer (Incensario)",
        "censer|ceramic|ceramics-containers",
        "ao/mobile-large/DT7407.jpg",
        0.80
    ),
    SearchData(
        750,
        316274,
        "Plate with Trumpeter",
        "plate|ceramic|ceramics-containers",
        "ao/mobile-large/DP-24261-001.jpg",
        1.02
    ),
    SearchData(
        650,
        313254,
        "Animal Head Hacha",
        "hacha|stone|stone-sculpture",
        "ao/mobile-large/DP-23868-001.jpg",
        1.13
    ),
    SearchData(
        550,
        317121,
        "Earflare",
        "earflare|jade|stone-ornaments",
        "ao/mobile-large/VS1994_35_583.JPG",
        1.21
    ),
    SearchData(
        800,
        320147,
        "Figure",
        "figure|ceramic|ceramics-sculpture",
        "ao/mobile-large/DP221679.jpg",
        0.75
    ),
    SearchData(
        1400,
        317237,
        "Celt",
        "celt|stone|stone-implements",
        "ao/mobile-large/hz1994_35_371.jpg",
        0.79
    ),
    SearchData(
        50,
        319227,
        "House Model",
        "house model|ceramic|ceramics-sculpture",
        "ao/mobile-large/DP-23908-001.jpg",
        0.90
    ),
    SearchData(
        700,
        317712,
        "Head Pendant",
        "pendant|shell|shell-ornaments",
        "ao/mobile-large/262187.jpg",
        0.64
    ),
    SearchData(
        1400,
        318653,
        "Celt",
        "celt|stone|stone-implements",
        "ao/mobile-large/hz1994_35_352.jpg",
        0.84
    ),
    SearchData(
        1400,
        317297,
        "Celt-Form Pendant",
        "pendant|stone|stone-ornaments",
        "ao/mobile-large/VS1994_35_441.JPG",
        0.61
    ),
    SearchData(
        749,
        718242,
        "Tripod Plate, Mythological Scene",
        "plate|ceramic with red, cream, and black slip|ceramics",
        "ao/mobile-large/DP-23101-003.jpg",
        1.02
    ),
    SearchData(
        800,
        320205,
        "Figure",
        "figure|ceramic, hematite|ceramics-sculpture",
        "ao/mobile-large/DP220954.jpg",
        0.75
    ),
    SearchData(
        550,
        317429,
        "Earflare Set",
        "earflare set|jade|stone-ornaments",
        "ao/mobile-large/VS1994_35_590.JPG",
        1.80
    ),
    SearchData(
        1400,
        317265,
        "Celt",
        "celt|stone|stone-implements",
        "ao/mobile-large/hz1994_35_399.jpg",
        0.64
    ),
    SearchData(
        1400,
        317235,
        "Celt",
        "celt|stone|stone-implements",
        "ao/mobile-large/hz1994_35_369.jpg",
        0.87
    ),
    SearchData(
        700,
        313241,
        "Vessel",
        "vessel|ceramic|ceramics-containers",
        "ao/mobile-large/1979.206.1048_a.JPG",
        0.93
    ),
    SearchData(
        750,
        313335,
        "Crocodile Rattle",
        "rattle|ceramic|ceramics-musical instruments",
        "ao/mobile-large/DT9416.jpg",
        1.25
    ),
    SearchData(
        1475,
        307634,
        "Cihuateotl",
        "figure|stone, pigment|stone-sculpture",
        "ao/mobile-large/DT5116.jpg",
        0.80
    ),
    SearchData(
        550,
        317760,
        "Pair of Carved Ornaments",
        "earflare frontals|shell|shell-ornaments",
        "ao/mobile-large/DP-14786-044.jpg",
        1.29
    ),
    SearchData(
        -1050,
        316302,
        "Bowl (Tecomate)",
        "bowl|ceramic|ceramics-containers",
        "ao/mobile-large/DP23126.jpg",
        0.93
    ),
    SearchData(
        550,
        318405,
        "Carved Bowl",
        "bowl|ceramic|ceramics-containers",
        "ao/mobile-large/DT4631.jpg",
        1.25
    ),
    SearchData(
        1400,
        317597,
        "Polishing Stone (?)",
        "polishing stone|stone|stone-implements",
        "ao/mobile-large/vs1994_35_764.jpg",
        0.96
    ),
    SearchData(
        700,
        310364,
        "Vessel, Mythological Scene",
        "vessel|ceramic, pigment|ceramics-containers",
        "ao/mobile-large/DP-576-001.jpg",
        0.74
    ),
    SearchData(
        300,
        314827,
        "Tripod Bird Bowl",
        "bowl with lid|ceramic|ceramics-containers",
        "ao/mobile-large/DT4867.jpg",
        0.80
    ),
    SearchData(
        750,
        312162,
        "Bowl",
        "bowl|ceramic|ceramics-containers",
        "ao/mobile-large/1979.205.7.JPG",
        1.50
    ),
    SearchData(
        1400,
        317266,
        "Celt",
        "celt|stone|stone-implements",
        "ao/mobile-large/hz1994_35_400.jpg",
        0.60
    ),
    SearchData(
        300,
        312161,
        "Bottle (Florero)",
        "bottle|ceramic|ceramics-containers",
        "ao/mobile-large/DP101922.jpg",
        0.90
    ),
    SearchData(
        700,
        319586,
        "Pendant with Seated Lord",
        "pendant|jadeite|stone-ornaments",
        "ao/mobile-large/DP131715.jpg",
        0.75
    ),
    SearchData(
        450,
        310542,
        "Double-Chambered Vessel",
        "vessel with lid|ceramic|ceramics-containers",
        "ao/mobile-large/DP-23468-001.jpg",
        0.77
    ),
    SearchData(
        1400,
        317103,
        "Celt",
        "celt|stone|stone-implements",
        "ao/mobile-large/hz1994_35_338.jpg",
        0.95
    ),
    SearchData(
        700,
        319009,
        "Covered Bowl",
        "bowl with lid|ceramic|ceramics-containers",
        "ao/mobile-large/DP-23884-001.jpg",
        0.93
    ),
    SearchData(
        1460,
        316873,
        "Temple Model",
        "temple model|ceramic|ceramics-sculpture",
        "ao/mobile-large/DP341942.jpg",
        0.75
    ),
    SearchData(
        700,
        310475,
        "Head from a Figure",
        "head|ceramic|ceramics-sculpture",
        "ao/mobile-large/1978.412.19.JPG",
        0.72
    ),
    SearchData(
        800,
        316267,
        "Ball Player",
        "male figure|ceramic|ceramics-sculpture",
        "ao/mobile-large/DP-23878-001.jpg",
        0.67
    ),
    SearchData(
        150,
        314524,
        "Cylindrical Vessel",
        "vessel|ceramic|ceramics-containers",
        "ao/mobile-large/h1_1982.207.7.jpg",
        0.71
    ),
    SearchData(
        -650,
        313337,
        "Ritual Spoon Pendant",
        "pendant|jadeite|stone-ornaments",
        "ao/mobile-large/DP-25108-001.jpg",
        0.46
    ),
    SearchData(
        699,
        53939,
        "Head Pendant",
        "pendant|jade (jadeite)|jade",
        "as/mobile-large/DP-14791-008.jpg",
        0.75
    ),
    SearchData(
        750,
        313151,
        "Costumed Figure",
        "male figure|ceramic, pigment|ceramics-musical instruments",
        "ao/mobile-large/1979.206.953_a.JPG",
        0.67
    ),
    SearchData(
        1400,
        317305,
        "Celt",
        "chisel|stone|stone-implements",
        "ao/mobile-large/VS1994_35_449.JPG",
        1.46
    ),
    SearchData(
        699,
        662967,
        "Codex-Style Vase with Mythological Scene",
        "vase|ceramic|ceramics-vessels",
        "ao/mobile-large/DP348021.jpg",
        0.75
    ),
    SearchData(
        -650,
        749344,
        "Kneeling Bearded Figure",
        "figure|serpentine|stone-sculpture",
        "ao/mobile-large/DP15497-009-.jpg",
        0.80
    ),
    SearchData(
        -1000,
        316301,
        "Bowl (Tecomate)",
        "bowl|ceramic|ceramics-containers",
        "ao/mobile-large/DP-23910-001.jpg",
        1.16
    ),
    SearchData(
        1399,
        705547,
        "Necklace with Beads in the Shape of Jaguar Teeth",
        "necklace|gold|metalwork-gold",
        "ao/mobile-large/DP-14865-001.jpg",
        1.33
    ),
    SearchData(
        -600,
        310513,
        "Pendant",
        "pendant|jade|stone-ornaments",
        "ao/mobile-large/vs1978_412_57.jpg",
        1.66
    ),
    SearchData(
        800,
        317619,
        "Turkey Vessel",
        "vessel|ceramic, slip, pigment|ceramics-containers",
        "ao/mobile-large/hz1998_71.jpg",
        1.31
    ),
    SearchData(
        750,
        313325,
        "Ceremonial Handle (?)",
        "handle|jade (jadeite/omphacite)|stone-sculpture",
        "ao/mobile-large/DP102172corrected.jpg",
        0.87
    ),
    SearchData(
        -1000,
        313319,
        "Small Yoke with Face",
        "yoke|stone|stone-sculpture",
        "ao/mobile-large/DP-24242-001.jpg",
        1.22
    ),
    SearchData(
        700,
        313342,
        "Figure with Helmet Mask",
        "male figure|ceramic, pigment|ceramics-sculpture",
        "ao/mobile-large/1979.206.1150_a1.JPG",
        1.07
    ),
    SearchData(
        1400,
        317106,
        "Celt",
        "celt|stone|stone-implements",
        "ao/mobile-large/hz1994_35_341.jpg",
        1.00
    ),
    SearchData(
        1400,
        315730,
        "Footed Vessel",
        "bowl|calcite|stone-containers",
        "ao/mobile-large/1989.314.25.JPG",
        0.81
    ),
    SearchData(
        772,
        313240,
        "Relief with Enthroned Ruler",
        "relief|limestone, paint|stone-sculpture",
        "ao/mobile-large/DP104826.jpg",
        0.99
    ),
    SearchData(
        -1000,
        318464,
        "Duck-Head Vessel",
        "vessel|ceramic|ceramics-containers",
        "ao/mobile-large/DP705381.jpg",
        0.98
    ),
    SearchData(
        650,
        701645,
        "Pendant",
        "pendant|jadeite, pigment|stone-ornaments",
        "ao/mobile-large/DP-25104-001.jpg",
        0.63
    ),
    SearchData(
        -750,
        317697,
        "Eagle Transformation Figure",
        "figure|albitite, cinnabar|stone-sculpture",
        "ao/mobile-large/DP-25107-001.jpg",
        0.58
    ),
    SearchData(
        550,
        313256,
        "Mirror-Bearer",
        "male figure|wood, red hematite|wood-sculpture",
        "ao/mobile-large/DP-24340-001.jpg",
        0.73
    ),
    SearchData(
        1400,
        317295,
        "Celt",
        "celt|stone|stone-implements",
        "ao/mobile-large/VS1994_35_439.JPG",
        0.46
    ),
    SearchData(
        750,
        318463,
        "Pendant with Figure and Double-Headed Crocodilian",
        "pendant|shell|shell-ornaments",
        "ao/mobile-large/DP-25095-001.jpg",
        1.33
    ),
    SearchData(
        700,
        310555,
        "Bird Ornament",
        "ornament|shell|shell-ornaments",
        "ao/mobile-large/DP-23474-001.jpg",
        1.09
    ),
    SearchData(
        1400,
        317225,
        "Celt",
        "celt|stone|stone-implements",
        "ao/mobile-large/hz1994_35_359.jpg",
        0.67
    ),
    SearchData(
        1400,
        317275,
        "Celt",
        "celt|stone|stone-implements",
        "ao/mobile-large/hz1994_35_409.jpg",
        2.77
    ),
    SearchData(
        700,
        319873,
        "Deity Face Pendant",
        "pendant|jadeite/omphacite, iron ochre|stone-ornaments",
        "ao/mobile-large/DP148420.jpg",
        0.75
    ),
    SearchData(
        700,
        316711,
        "Vessel with Seated Lord",
        "vessel|ceramic, stucco|ceramics-containers",
        "ao/mobile-large/DP-24262-001.jpg",
        0.86
    ),
    SearchData(
        700,
        312595,
        "Seated Female Figure",
        "female figure|ceramic|ceramics-musical instruments",
        "ao/mobile-large/DP-12659-001.jpg",
        0.75
    ),
    SearchData(
        750,
        318628,
        "Cylinder Vessel",
        "vessel|ceramic, slip, stucco|ceramics-containers",
        "ao/mobile-large/1979.205.8.JPG",
        0.85
    ),
    SearchData(
        1300,
        313257,
        "Crocodile-Head Figure Pendant",
        "pendant|gold (cast alloy), pyrite inlay|metal-ornaments",
        "ao/mobile-large/VS19792061064.JPG",
        0.70
    ),
    SearchData(
        1400,
        317263,
        "Celt",
        "celt|stone|stone-implements",
        "ao/mobile-large/hz1994_35_397.jpg",
        0.70
    ),
    SearchData(
        737,
        318662,
        "Vessel, Throne Scene",
        "vessel|ceramic, pigment|ceramics-containers",
        "ao/mobile-large/DT4514.jpg",
        0.80
    ),
    SearchData(
        150,
        316300,
        "Cylindrical Vessel",
        "vessel|ceramic|ceramics-containers",
        "ao/mobile-large/DP242327.jpg",
        1.03
    ),
    SearchData(
        -99,
        314522,
        "Tetrapod Jar",
        "bowl|ceramic|ceramics-containers",
        "ao/mobile-large/DP23127.jpg",
        1.03
    ),
    SearchData(
        1400,
        317320,
        "Blade",
        "blade|flint|stone-implements",
        "ao/mobile-large/hz1994_35_464.jpg",
        0.43
    ),
    SearchData(
        750,
        312645,
        "Palma with textile motif",
        "palma|stone, pigment|stone-sculpture",
        "ao/mobile-large/DP104834.jpg",
        0.83
    ),
    SearchData(
        550,
        314832,
        "Shell Ornament",
        "pendant|jade|stone-ornaments",
        "ao/mobile-large/vs1985_216_2.jpg",
        2.35
    ),
    SearchData(
        1400,
        317246,
        "Celt",
        "celt|stone|stone-implements",
        "ao/mobile-large/hz1994_35_380.jpg",
        0.60
    ),
    SearchData(
        50,
        677436,
        "Human Figure",
        "figure|clay|ceramics-sculpture",
        "ao/mobile-large/LC-300_5434.jpg",
        1.34
    ),
    SearchData(
        1843,
        591853,
        "Incidents of Travel in Yucatan",
        "|illustrated book|",
        "li/mobile-large/liUDs83v2.R.jpg",
        1.53
    ),
    SearchData(
        1470,
        321292,
        "Head from a figure, Xochipilli-Macuilxochitl",
        "head|obsidian|glass-sculpture",
        "ao/mobile-large/TR.451.2.2012_a.jpg",
        1.60
    ),
    SearchData(
        300,
        313035,
        "Ornament with Maya Glyph",
        "ornament|jadeite|stone-ornaments",
        "ao/mobile-large/VS1979206858A.JPG",
        1.23
    ),
    SearchData(
        900,
        316304,
        "Tripod Plate",
        "plate|ceramic|ceramics-containers",
        "ao/mobile-large/DP219258.jpg",
        0.81
    ),
    SearchData(
        700,
        310644,
        "Scepter with Profile Figures",
        "scepter|flint|stone-sculpture",
        "ao/mobile-large/DT10197.jpg",
        0.79
    ),
    SearchData(
        1400,
        317358,
        "Tubular Bead",
        "bead|stone|beads-ornaments",
        "ao/mobile-large/VS1994_35_508.JPG",
        2.59
    ),
    SearchData(
        1000,
        310480,
        "Head of a Rain God",
        "head|fossiliferous limestone|stone-sculpture",
        "ao/mobile-large/DP102948.jpg",
        0.99
    ),
    SearchData(
        800,
        318678,
        "Standing Figure",
        "figure|ceramic|ceramics-sculpture",
        "ao/mobile-large/vs00_5_176.jpg",
        0.96
    ),
    SearchData(
        749,
        761272,
        "Vessel with Water Bird and Hieroglyphic Text",
        "vessel|ceramic|ceramics-vessels",
        "ao/mobile-large/DP-15497-005.jpg",
        1.21
    ),
    SearchData(
        -650,
        316288,
        "Celt",
        "celt|jade|stone-ornaments",
        "ao/mobile-large/1989.314.4.jpg",
        0.67
    ),
    SearchData(
        700,
        312818,
        "Ornamental Figure",
        "ornament|shell|shell-ornaments",
        "ao/mobile-large/vs1979_206_622.jpg",
        0.38
    ),
    SearchData(
        900,
        307443,
        "Fragmentary Relief",
        "relief|stone|stone-sculpture",
        "ao/mobile-large/DP-20489-002.jpg",
        1.43
    ),
    SearchData(
        300,
        315884,
        "Lidded Vessel",
        "bowl with lid|ceramic, slip, pigment|ceramics-containers",
        "ao/mobile-large/1987.450.2ab1.JPG",
        1.30
    ),
    SearchData(
        1400,
        317365,
        "Tubular Bead",
        "bead|stone|beads-ornaments",
        "ao/mobile-large/VS1994_35_515.JPG",
        3.53
    ),
    SearchData(
        -650,
        310495,
        "Yoke",
        "yoke|stone, pigment|stone-sculpture",
        "ao/mobile-large/DT10169.jpg",
        0.80
    ),
    SearchData(
        700,
        314305,
        "Bowl",
        "bowl|ceramic, slip, pigment|ceramics-containers",
        "ao/mobile-large/1983.505_a.JPG",
        1.50
    ),
    SearchData(
        550,
        317430,
        "Earflare Set",
        "earflare set|jade|stone-ornaments",
        "ao/mobile-large/VS1994_35_591.JPG",
        1.79
    ),
    SearchData(
        800,
        320206,
        "Figure",
        "figure|ceramic|ceramics-sculpture",
        "ao/mobile-large/DP220955.jpg",
        0.75
    ),
    SearchData(
        500,
        310354,
        "Bowl with Pouring Lip",
        "bowl|ceramic|ceramics-containers",
        "ao/mobile-large/1978.309.1.JPG",
        1.12
    ),
    SearchData(
        1400,
        317212,
        "Celt",
        "celt|stone|stone-implements",
        "ao/mobile-large/hz1994_35_345.jpg",
        0.64
    ),
    SearchData(
        750,
        312804,
        "Figure Rattle",
        "rattle|ceramic, pigment|ceramics-musical instruments",
        "ao/mobile-large/1979.206.608.JPG",
        0.70
    ),
    SearchData(
        900,
        313242,
        "Bowl",
        "bowl|ceramic|ceramics-containers",
        "ao/mobile-large/1979.206.1049_a.JPG",
        1.23
    ),
    SearchData(
        550,
        315035,
        "Head Pendant",
        "pendant|stone|stone-ornaments",
        "ao/mobile-large/vs1986_483.jpg",
        0.57
    ),
    SearchData(
        200,
        314518,
        "Tetrapod Bowl",
        "vessel|ceramic|ceramics-containers",
        "ao/mobile-large/DP-13003-001.jpg",
        1.25
    ),
)